// extracted by mini-css-extract-plugin
export default {"tag-value-text":"DetailDrawer_tag-value-text__jMyl+","hyperlink":"DetailDrawer_hyperlink__A0iUH","tag-divider":"DetailDrawer_tag-divider__1E9Rt"};